import React, { Context, createContext, useContext, useState } from 'react';
import { useForm } from '@uhg-abyss/web/hooks/useForm';
import { FormProvider } from '@uhg-abyss/web/ui/FormProvider';

const ProfileForm = createContext<{
  form: Record<any, any>;
  editMode: boolean;
  toggleEditMode: () => void;
  handleSubmit: () => void;
  handleReset: () => void;
  search: string;
  submitterList:Record<any, any>;
  setSearch: any;
  demIndex: string;
  setDemIndex: any;
  demList: Record<any, any>;
  profileLists: Record<any, any>;
  setDemList: any;
  onVersionChange: any;
  isSearchEnabled: boolean;
  setIsSearchEnabled: () => void;
  versionNumber: string,
  setVersionNumber: () => void,
  submitterID:string,
  setSubmitterID: () => void,
  // fetchDataBysearch:() => void,
  // updateSubmitterDeatils:() => void,
  // fetchProfileBySumbitterChange:() => any,
}>({
  form: {
    watch: () => { },
    setValue: () => { },
    getValues: () => { },
  },
  editMode: false,
  toggleEditMode: () => { },
  // handleSubmit: () => { },
  handleReset: () => { },
  search: '',
  setSearch: () => { },
  demIndex: '',
  versionNumber: '',
  setVersionNumber: () => { },
  submitterID: "",
  setSubmitterID: () => { },
  setDemIndex: () => { },
  demList: [],
  profileLists: [],
  setDemList: () => { },
  onVersionChange: () => { },
  isSearchEnabled: false,
  submitterList:[],
  setIsSearchEnabled: () => { },
  fetchDataBysearch:() => { },
  updateSubmitterDeatils:() => { },
  fetchProfileBySumbitterChange:() => { },
});

export const CustomerProfileProvider = ({
  children,
  searchObj,
  form,

  onReset,
  profileLists
}) => {
  const [editMode, setEditMode] = useState(false);
  const [isSearchEnabled, setIsSearchEnabled] = useState(false);


  const toggleEditMode = () => setEditMode((prev) => !prev);
  return (
    <ProfileForm.Provider
      value={{
        form,
        editMode,
        isSearchEnabled,
        profileLists,
        setIsSearchEnabled,
        toggleEditMode,


        handleReset: onReset,
        ...searchObj,
      }}
    >
      <FormProvider state={form}>
        {children}
      </FormProvider>
    </ProfileForm.Provider>
  );
};

export const useCustomerProfileForm = () => {
  return useContext(ProfileForm);
};
